import { Component, Input } from '@angular/core';

@Component({
  selector: 'getm-coins-badge',
  templateUrl: './coins-badge.component.html',
  styleUrls: ['./coins-badge.component.scss'],
})
export class CoinsBadgeComponent {

  @Input() icon: string = 'getm-pepsi-point';
  @Input() iconColor: string = 'getm-primary-default';
  @Input() text: string = '';
  @Input() textColor: string = 'getm-disabled-dark';
  @Input() size: 'large' | 'small' = 'large';

  constructor() { }

}
